import { TERMINE_TERMIN_CREATE } from '@/domain/termine/hooks/graphql/mutation';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';
import { toGraphQLMarkierung } from '@/domain/termine/shared/types/Markierung';
import {
  TerminWiederholung,
  wiederholungToGraphQLMap,
} from '@/domain/termine/shared/types/TerminWiederholung';
import {
  CreateTerminMutation,
  CreateTerminMutationVariables,
  Termine_TerminCreateInput,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';

export function useCreateTermine() {
  const [mutate, { data, loading }] = useMutation<
    CreateTerminMutation,
    CreateTerminMutationVariables
  >(TERMINE_TERMIN_CREATE, {
    refetchQueries: ['GetTagesDaten'],
    awaitRefetchQueries: true,
  });

  const createTermin = async (termin: FormValues) => {
    let terminInput: Termine_TerminCreateInput = {
      datum: termin.datum,
      titel: termin.titel,
      beschreibung: termin.beschreibung,
      specials: termin.specials,
      standortId: termin.standortId,
      markierung: toGraphQLMarkierung(termin.markierung),
      wiederholung:
        wiederholungToGraphQLMap[
          termin.wiederholung ?? TerminWiederholung.OHNE
        ],
      beginn: termin.beginn,
      ende: termin.ende,
      wiederholungBis: termin.wiederholungBis,
      terminImage: termin.terminBildInput,
    };

    if (termin.terminKalenderId && termin.terminKalenderId !== 'NO_KALENDER') {
      terminInput = {
        ...terminInput,
        terminKalenderId: termin.terminKalenderId,
      };
    }
    const result = await mutate({
      variables: {
        termin: terminInput,
      },
    });
    return result.data?.termine_terminCreate;
  };

  return {
    createTermin,
    response: data?.termine_terminCreate,
    loading,
  };
}
